import React from 'react';
import TestTicketService from './ticketSystem/TestTicketService';
import { usePermissions } from '../../company-management/hooks/usePermissions';
import { PERMISSIONS } from '../../company-management/constants/permissions';
import { Navigate, useNavigate } from 'react-router-dom';
import './SupportPage.css';

const ENABLE_TEST_PANEL = false;

const SupportPage = () => {
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  if (!hasPermission(PERMISSIONS.SUPPORT.VIEW)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div className="support-page">
      <header className="support-page__header">
        <h1 className="support-page__title">Support Center</h1>
        <p className="support-page__subtitle">
          We're here to help you with any questions or issues you may have.
        </p>
      </header>

      {process.env.NODE_ENV === 'development' && ENABLE_TEST_PANEL && (
        <div className="support-page__test-panel">
          <TestTicketService />
        </div>
      )}

      <div className="support-page__options">
        <section className="support-page__card">
          <div className="support-page__card-row">
            <div className="support-page__card-text">
              <h2 className="support-page__card-title">Submit a Support Ticket</h2>
              <p className="support-page__card-desc">
                Use tickets for account issues, billing questions, bugs, or feature requests. You can track replies in one place.
              </p>
            </div>
            <button
              type="button"
              className="support-page__btn"
              onClick={() => navigate('/app/overview/support/tickets')}
            >
              Open Ticketing
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SupportPage;
